// Variant selection in product grid
document.addEventListener('click', function (e) {
  const variantBtn = e.target.closest('.grid-product__variant')
  if (!variantBtn || variantBtn.hasAttribute('disabled')) {
    return
  }

  e.preventDefault()
  e.stopPropagation()

  const variantId = variantBtn.getAttribute('data-variant-id')
  const variantPrice = variantBtn.getAttribute('data-variant-price')
  const variantImage = variantBtn.getAttribute('data-variant-image')
  const gridItem = variantBtn.closest('.grid-product')
  if (!gridItem) return

  const addButton = gridItem.querySelector('.js-quick-add-btn')
  const activeVariant = gridItem.querySelector('.grid-product__variant.active')

  if (activeVariant) {
    activeVariant.classList.remove('active')
  }
  variantBtn.classList.add('active')

  if (addButton) {
    addButton.setAttribute('data-id', variantId)
    const addButtonPrice = addButton.querySelector('.grid-product__price')
    if (addButtonPrice) {
      addButtonPrice.innerText = variantPrice
    }
  }

  // Update featured image to variant image when size/variant is selected
  const primaryImg = gridItem.querySelector('[data-product-card-primary-img]')
  const primaryWrap = primaryImg ? primaryImg.closest('[data-default-src]') : null
  const defaultSrc = primaryWrap ? primaryWrap.getAttribute('data-default-src') : null
  const newSrc = variantImage || defaultSrc

  if (primaryImg && newSrc) {
    requestAnimationFrame(function () {
      // Card image is shown via srcset (responsive); update src and srcset so it swaps
      primaryImg.setAttribute('data-src', newSrc)
      primaryImg.setAttribute('src', newSrc)
      primaryImg.setAttribute('srcset', newSrc)
      primaryImg.setAttribute('data-srcset', newSrc)
      primaryImg.classList.remove('lazyload')
      primaryImg.classList.add('lazyloaded')
    })
  }
})